import { takeEvery } from "@redux-saga/core/effects";
import { SelectableOptionsActionTypes } from "./../types";
import { addOptionSaga } from "./addOption";
import { deleteOptionSaga } from "./deleteOption";
import { updateOptionSaga } from "./updateOption";

import { initialOptionsSaga } from "./initalOptions";
import { deleteBulkOptionsSaga } from "./deleteBulkOptions";
import { addBulkOptionsSaga } from "./addBulkOptions";
import { switchOptionsSaga } from "./switchOptions";

import { duplicateOptionsSaga } from "./duplicateOptions";

export default function* selectableOptionsSaga() {
    yield takeEvery(SelectableOptionsActionTypes.INITIAL_OPTIONS, initialOptionsSaga);
    yield takeEvery(SelectableOptionsActionTypes.ADD_OPTION_REQUEST, addOptionSaga);
    yield takeEvery(SelectableOptionsActionTypes.DELETE_OPTION_REQUEST, deleteOptionSaga);
    yield takeEvery(SelectableOptionsActionTypes.UPDATE_OPTION_REQUEST, updateOptionSaga);
    yield takeEvery(SelectableOptionsActionTypes.SWITCH_OPTIONS, switchOptionsSaga);
    yield takeEvery(SelectableOptionsActionTypes.DUPLICATE_OPTIONS, duplicateOptionsSaga);
    yield takeEvery(SelectableOptionsActionTypes.ADD_BULK_OPTION_REQUEST, addBulkOptionsSaga);
    yield takeEvery(SelectableOptionsActionTypes.DELETE_BULK_OPTION_REQUEST, deleteBulkOptionsSaga);
}
